<template>
	<div v-parallax-fit="parallax" class="foto">
		<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/28_FinalPhoto_04@2x.png" alt="">
	</div>
</template>

<script>
export default {
	data() {
		return {
			parallax: [
				{
					start: 36200,
					end: 37200,
					fromStyle: { transform: 'translateY(0%) translateX(500%) rotate(0deg)' },
					toStyle: { transform: 'translateY(0%) translateX(0%) rotate(17deg)' },
					easing: 'linear'
				},
				{
					start: 37800,
					end: 38200,
					fromStyle: { transform: 'translateY(0%) translateX(0%) rotate(17deg)' },
					toStyle: { transform: 'translateY(0%) translateX(-500%) rotate(0deg)' },
					easing: 'linear'
				},
			]
		}
	}
}
</script>

<style lang="scss" scoped>
.foto {
	position: absolute;
	top: 0;
	right: 0;
	max-width: 300px;
	margin-right: 23px;
	margin-top: 130px;
	z-index: 2;
	// transition: all 0.7s easeOutQuint;
	transition: all 500ms cubic-bezier(0.730, 0.055, 0.100, 0.845);
}

@media screen and (max-width: 1600px) {
	.foto {
		max-width: 250px;
		margin-right: 44px;
		margin-top: 150px;
	}
}

@media screen and (max-width: 991px) {
	.foto {
		max-width: 180px;
		margin-right: 60px;
		margin-top: 130px;
	}
}

@media screen and (max-width: 650px) {
	.foto {
		max-width: 130px;
		margin-right: 30px;
		margin-top: 70px;
	}
}
</style>
